<template>
  <div class="p-t-24 p-l-24 p-r-24 h100">
    <div class="flex-column h100">
      <div v-if="objectionInfo.objectionId" class="objection-head">
        <div class="objection-head__title text-bold">
          {{ objectionInfo.objectionName || '-' }}
        </div>
        <jczh-descriptions
          :el-attrs="{ size: 'medium', column: 3 }"
          :option="options1"
          :info="objectionInfo"
        />
        <jczh-descriptions
          :el-attrs="{ size: 'medium', column: 3 }"
          :option="options2"
          :info="objectionInfo"
        />
      </div>
      <div class="flex-1 objection-step">
        <div v-if="!qaList.length" class="objection-empty">暂无数据</div>
        <el-scrollbar
          v-else
          ref="scrollbar"
          class="scrollbar-y-hidden"
          style="height: 100%;"
        >
          <div ref="stepRef" class="p-l-10">
            <a-steps progress-dot :current="current" direction="vertical">
              <a-step
                v-for="(item, index) in qaList"
                :id="getCurrentId(index)"
                :key="index"
              >
                <div slot="title" class="objection-step__title">
                  <span class="text-bold">{{ getRecordType(item) }}</span>
                  <span v-if="!item.isEditing" class="time">
                    {{ item.submitTime || '-' }}
                  </span>
                </div>
                <div slot="description" class="objection-step__main">
                  <template v-if="item.isEditing">
                    <objection-operate
                      :type="type"
                      @cancel="onCancel"
                      @submit="onSubmit"
                    />
                  </template>

                  <template v-else>
                    <el-form label-width="0">
                      <el-form-item label="" class="m-b-12">
                        <div class="content">{{ item.content || '-' }}</div>
                      </el-form-item>
                      <el-form-item
                        v-if="item.attachmentIds && item.attachmentIds.length"
                        label="附件："
                        label-width="60px"
                        class="m-b-16"
                      >
                        <upload
                          :file-id-before.sync="item.attachmentIds"
                          :props-data="{
                            disabled: true,
                            uploadMode: 'fileId'
                          }"
                        />
                      </el-form-item>

                      <el-form-item
                        v-if="isObjectBtn(item, index) && !isOperate"
                      >
                        <el-button
                          type="primary"
                          @click="onOperate(item, 'object')"
                        >
                          继续异议
                        </el-button>
                      </el-form-item>
                      <el-form-item
                        v-if="isReplyBtn(item, index) && !isOperate"
                      >
                        <el-button
                          type="primary"
                          @click="onOperate(item, 'reply')"
                        >
                          异议答复
                        </el-button>
                      </el-form-item>
                    </el-form>
                  </template>
                </div>
              </a-step>
            </a-steps>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
// 组件
import Upload from '@/components/common/Upload/index'
import ObjectionOperate from '@/components/bid/Objection/ObjectionOperate'

// 数据字典
import {
  objectionRecordTypeDict,
  objectionTypeDict
} from '@/dictionary/project/common'
import { workbenchServiceDict } from '@/dictionary/system'
import { queryOrganizationDict } from '@/dictionary/query-status'

// 后端api
import { setPurchaserObjectionsAskApi } from '@/api/procure/objection'
import { setSupplierObjectionsAppendQuestionApi } from '@/api/supplier/objection'

export default {
  components: {
    Upload,
    ObjectionOperate
  },

  props: {
    type: {
      type: [String, Number],
      default: workbenchServiceDict.PURCHASER.value
    },

    objectionInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      workbenchServiceDict,
      objectionRecordTypeDict,

      options1: [
        {
          label: '异议类型',
          prop: 'objectionType',
          dictArray: objectionTypeDict.array
        },
        { label: '招标编号', prop: 'objectionCode' }
      ],

      // 问答列表
      qaList: [],

      isOperate: false
    }
  },

  computed: {
    // 是否是供应商操作
    isSupplier() {
      return this.type === workbenchServiceDict.SUPPLIER.value
    },

    /**
     * 限制采购人异议答复
     * 采购人工作台&委托采购项目 不能异议答复
     */
    isLimitAnswer() {
      return (
        this.type === workbenchServiceDict.PURCHASER.value &&
        this.objectionInfo?.entrustType == queryOrganizationDict.ENTRUST.value
      )
    },

    // 当前步骤
    current() {
      return this.qaList.length ? this.qaList.length - 1 : 0
    },

    options2() {
      return [
        { label: '联系人', prop: 'contactUserName' },
        { label: '联系电话', prop: 'contactUserPhone' },
        this.isSupplier
          ? { label: '项目单位', prop: 'ownerCompanyName' }
          : { label: '提出异议单位', prop: 'supplierName' }
      ]
    }
  },

  watch: {
    objectionInfo: {
      handler(val) {
        this.isOperate = false
        this.qaList = [...(val?.qaList || [])]
        this.setScroll()
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {},

  methods: {
    setScroll() {
      this.$nextTick(() => {
        document.getElementById('scrollStepId') &&
          document.getElementById('scrollStepId').scrollIntoView({
            behavior: 'smooth'
          })
      })
    },

    /**
     * 设置id值
     */
    getCurrentId(index) {
      const tempList = this.qaList.filter(x => !x.isEditing)
      if (this.isSupplier) {
        return index == tempList.length - 2 ? 'scrollStepId' : ''
      } else {
        return index == tempList.length - 1 ? 'scrollStepId' : ''
      }
    },

    /**
     * 获取异议问题类型
     */
    getRecordType(item) {
      if (
        this.isSupplier &&
        item.recordType == objectionRecordTypeDict.OBJECT.value
      ) {
        return '您的' + objectionRecordTypeDict.OBJECT.label
      }
      return objectionRecordTypeDict.translate(item.recordType)?.label || '-'
    },

    /**
     * 是否展示继续异议
     * 供应商工作台&当前步骤是异议回复&当前是问答列表最新一项
     */
    isObjectBtn(item, index) {
      const tempList = this.qaList.filter(x => !x.isEditing)
      return (
        this.isSupplier &&
        item.recordType == objectionRecordTypeDict.REPLY.value &&
        index == tempList.length - 1
      )
    },

    /**
     * 是否展示异议答复
     * !isLimitAnswer & (采购工作台/代理机构工作台)&当前步骤是异议&当前是问答列表最新一项
     */
    isReplyBtn(item, index) {
      const tempList = this.qaList.filter(x => !x.isEditing)
      return (
        !this.isLimitAnswer &&
        !this.isSupplier &&
        item.recordType == objectionRecordTypeDict.OBJECT.value &&
        index == tempList.length - 1
      )
    },

    /**
     * 操作继续异议/答复
     */
    onOperate(item, type) {
      this.isOperate = true
      this.qaList.push({
        isEditing: true,
        objectionId: item.objectionId,
        recordType:
          type == 'object'
            ? objectionRecordTypeDict.OBJECT.value
            : objectionRecordTypeDict.REPLY.value
      })

      this.$nextTick(() => {
        const scrollElem = this.$refs.scrollbar
        const stepElem = this.$refs.stepRef
        scrollElem &&
          scrollElem.$refs.wrap.scrollTo({
            top: stepElem.scrollHeight,
            behavior: 'smooth'
          })
      })
    },

    onCancel() {
      this.isOperate = false
      const idx = this.qaList.findIndex(item => item.isEditing)
      idx !== -1 && this.qaList.splice(idx, 1)
    },

    onSubmit(data) {
      if (this.isSupplier) {
        setSupplierObjectionsAppendQuestionApi({
          objectionId: this.objectionInfo.objectionId,
          ...data
        })
          .then(res => {
            this.$message.success('操作成功')
            this.$emit('complete')
          })
          .catch(err => {
            this.$message.error(err.message)
          })
      } else {
        setPurchaserObjectionsAskApi({
          objectionId: this.objectionInfo.objectionId,
          ...data
        })
          .then(res => {
            this.$message.success('操作成功')
            this.$emit('complete')
          })
          .catch(err => {
            this.$message.error(err.message)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.h100 {
  height: 100%;
}

.objection-head {
  padding-bottom: 14px;
  margin-bottom: 24px;
  border-bottom: 1px solid $info-fourth-color;

  &__title {
    margin-bottom: 16px;
    font-size: 20px;
    line-height: 24px;
    color: $text-color;
  }
}

.objection-step {
  overflow: hidden;
  ::v-deep .ant-steps-item .ant-steps-item-content {
    width: 95%;
  }

  &__title {
    font-size: 16px;
    line-height: 22pxpx;
    color: $text-color;

    .time {
      margin-left: 8px;
      font-size: 12px;
      line-height: 18px;
      color: $third-text-color;
    }
  }

  &__main {
    padding-top: 10px;
    .content {
      padding: 12px;
      background: $primary-fifth-color;
      border: 1px solid $body-background-color;
      border-radius: 4px;
      font-size: 14px;
      line-height: 22px;
      color: $second-text-color;
      word-break: break-all;
    }
  }
}

.objection-empty {
  padding: 76px 0 0;
  text-align: center;
  font-size: 16px;
  color: $third-text-color;
}
</style>
